import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { space } from '@sunwebgroup/ui-components'
import { RichText } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'
import { Item } from './Item'
import { MealplansItem } from './MealplansItem'

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_8')};
`

const MealplansDescription = styled.div`
  margin-bottom: ${space('primitives_space_16')};
`

export function Mealplans() {
  const mealplaninfo = useCMSPageField('PDP.mealplans')
  const items = mealplaninfo?.mealPlans
  const intl = useIntl()

  // This is needed to get the correct description for the mealplan based on the type
  function getDescription(code: string) {
    const isAllInclusive = code === 'AI' || code === 'UA'
    if (!isAllInclusive) {
      return undefined
    }

    return mealplaninfo?.allInclusiveDescription
  }

  if (!items || items.length === 0) {
    return null
  }

  return (
    <Item elementDL="Mealplans" title={intl.formatMessage({ id: 'practical_info_meal_plans_title' })} Glyph="ForkAndKnive">
      {mealplaninfo.description && (
        <MealplansDescription>
          <RichText innerHTML={mealplaninfo.description} />
        </MealplansDescription>
      )}
      <ItemContent>
        {items.map(mealplan => (
          <MealplansItem
            key={mealplan.type.code}
            mealplanCode={mealplan.type.code}
            title={mealplan.type.description}
            description={getDescription(mealplan.type.code)}
          />
        ))}
      </ItemContent>
    </Item>
  )
}
